import { createAction } from 'Utility/Redux';
import InfoMenuHandler from '../../System/UI/Menu/InfoMenuHandler';
import MoreLevelsComingHandler from '../../System/UI/NotImplemented/MoreLevelsComingHandler';
import StarChestInfoHandler from '../../System/UI/Menu/StarChestInfoHandler';
import FieldHarvestHandler from '../../System/UI/Menu/FieldHarvestHandler';
import SpecialOfferHandler from '../../System/UI/Menu/SpecialOfferHandler';
import SundayOfferHandler from '../../System/UI/Menu/SundayOfferHandler';
import { ShopPopup } from '../../System/UI/Menu/ShopPopup/ShopPopup';
import QuestsMenuHandler from '../../System/UI/Menu/QuestsMenuHandler';
import DailyLoginMenuHandler from '../../System/UI/Menu/DailyLoginMenuHandler';
import ThankYouFirstPurchaseHandler from '../../System/UI/Menu/ThankYouFirstPurchaseHandler';
import PayerReactivationHandler from '../../System/UI/Menu/PayerReactivationHandler';
import PetUnlockMenuHandler from '../../System/UI/Menu/PetUnlockMenuHandler';
import PrePetMiniGameMenuHandler from '../../System/UI/Menu/PrePetMiniGameMenuHandler';
import NoCoinsMenuHandler from '../../System/UI/NotImplemented/NoCoinsMenuHandler';
import FriendsHubHandler from '../../System/UI/Menu/FriendsHubHandler';
import ThreeStarShareHandler from '../../System/UI/Menu/ThreeStarShareHandler';
import QuitMenuHandler from '../../System/UI/Menu/QuitMenuHandler';
import CrossPromoMenuHandler from '../../System/UI/Menu/CrossPromoMenuHandler';
import BotOptInHandler from '../../System/UI/NotImplemented/BotOptInHandler';
import ErrorPopupHandler from '../../System/UI/ErrorPopupHandler';
import HelperFriendHUDHandler from '../../System/UI/HUD/HelperFriendHUDHandler';
import CrossPromoHUDHandler from '../../System/UI/HUD/CrossPromoHUDHandler';
import BoosterHUDHandler from '../../System/UI/HUD/BoosterHUDHandler';
import WorldHUDTravelHandler from '../../System/UI/HUD/WorldHUDTravelHandler';
import WorldHUDHandler from '../../System/UI/HUD/WorldHUDHandler';
import FieldUnlockedHandler from '../../System/UI/Menu/FieldUnlockedHandler';
import CropUnlockedHandler from '../../System/UI/Menu/CropUnlockedHandler';
import ThreeStarRewardMenuHandler from '../../System/UI/NotImplemented/ThreeStarRewardHandler';
import SentGiftMenuHandler from '../../System/UI/Menu/SentGiftMenuHandler';
import GiftMenuHandler from '../../System/UI/Menu/GiftMenuHandler';
import CropUnlockedShareHandler from '../../System/UI/Menu/CropUnlockedShareHandler';
import { PopupID } from './PopupID';
import { LevelPopup } from '../../System/UI/Menu/LevelPopup/LevelPopup';
import { BuyBoosterPopup } from '../../System/UI/Menu/LevelPopup/BuyBoosterPopup';
import { LevelCompletePopup } from '../../System/UI/Menu/LevelPopup/LevelCompletePopup';
import StreakInfoPopup from '../../Prototype/UI/Level/StreakInfoPopup';
import GDPRMenuHandler from 'System/UI/Menu/GDPRMenuHandler';
import ConfirmQuitGameHandler from 'System/UI/Menu/ConfirmQuitGameHandler';
import ConfirmSignOutMenuHandler from 'System/UI/Menu/ConfirmSignOutMenuHandler';
import DataConflictsMenuHandler from 'System/UI/Menu/DataConflictsMenuHandler';
import { WheelQuitConfirmPopup } from 'System/UI/WheelPopup/WheelQuitConfirmPopup';
import WheelPopup from 'System/UI/WheelPopup/WheelPopup';
import HardSharePopup from 'System/UI/Menu/LevelPopup/HardSharePopup';
import { LevelHud } from 'System/UI/HUD/LevelHud';
import { FarmHUDHandler } from 'System/UI/HUD/FarmHUDHandler';
import FarmMapHandler from 'System/Farm/Handler/FarmMapHandler';
import AreaUnlockPopup from 'System/Farm/Handler/AreaUnlockPopup';
import FarmSharePopup from 'System/UI/Menu/FarmPopup/FarmSharePopup';
import FarmCatalogueMenuHandler from 'System/UI/Menu/FarmCatalogueMenuHandler';
import FarmMiniGameMenuHandler from 'System/UI/Menu/FarmMiniGameMenuHandler';
import { UnlockItemsPopup } from 'System/UI/Menu/FarmPopup/UnlockItemsPopup';
import ConnectFbPopup from 'System/UI/Menu/ConnectFbPopup';
import { ConnectFbSplashScreen } from 'System/UI/Menu/ConnectFbSplashScreen';
import ProgressionPassedMobileVersion from "System/UI/Menu/ProgressionPassedMobileVersion";
import { SettingsPopup } from "@platform/System/UI/Menu/SettingsPopup";
import { EventOfferHandler } from 'System/UI/Menu/EventOfferHandler';
import { SideMenu } from "System/UI/Menu/LevelPopup/SideMenu";
import EventIntroHandler from "System/UI/Menu/EventIntroHandler";


enum Types {
    SHOW_POPUP = 'showPopup',
    HIDE_POPUP = 'hidePopup',
    QUEUE_POPUP = 'queuePopup',
    UPDATE_PARAMS = 'updateParams',
}

type PopupTypeById = {
    [PopupID.INFO_MENU]: InfoMenuHandler;
    [PopupID.MORE_LEVELS_COMING]: MoreLevelsComingHandler;
    [PopupID.STAR_CHEST_INFO]: StarChestInfoHandler;
    [PopupID.HARVEST_MENU]: FieldHarvestHandler;
    [PopupID.SPECIAL_OFFER_MENU]: SpecialOfferHandler;
    [PopupID.SUNDAY_OFFER_MENU]: SundayOfferHandler;
    [PopupID.SHOP_MENU]: ShopPopup;
    [PopupID.QUEST_MENU]: QuestsMenuHandler;
    [PopupID.DAILY_LOGIN_MENU]: DailyLoginMenuHandler;
    [PopupID.THANK_YOU_FIRST_PURCHASE]: ThankYouFirstPurchaseHandler;
    [PopupID.PAYER_REACTIVATION_MENU]: PayerReactivationHandler;
    [PopupID.PET_UNLOCK_MENU]: PetUnlockMenuHandler;
    [PopupID.PRE_PET_MINIGAME_MENU]: PrePetMiniGameMenuHandler;
    [PopupID.NO_COINS_MENU]: NoCoinsMenuHandler;
    [PopupID.FRIENDS_HUB]: FriendsHubHandler;
    [PopupID.SETTINGS_MENU]: SettingsPopup;
    [PopupID.THREE_STAR_SHARE_MENU]: ThreeStarShareHandler;
    [PopupID.HARD_LEVEL_SHARE_POPUP]: HardSharePopup;
    [PopupID.QUIT_MENU]: QuitMenuHandler;
    [PopupID.CROSS_PROMO_MENU]: CrossPromoMenuHandler;
    [PopupID.BOT_OPT_IN_MENU]: BotOptInHandler;
    [PopupID.LEVEL_HUD]: LevelHud;
    [PopupID.HELPER_FRIEND_HUD]: HelperFriendHUDHandler;
    [PopupID.CROSS_PROMO]: CrossPromoHUDHandler;
    [PopupID.BOOSTER_HUD]: BoosterHUDHandler;
    [PopupID.WORLD_HUD_TRAVEL]: WorldHUDTravelHandler;
    [PopupID.WORLD_HUD]: WorldHUDHandler;
    [PopupID.FIELD_UNLOCKED_MENU]: FieldUnlockedHandler;
    [PopupID.CROP_UNLOCK_MENU]: CropUnlockedHandler;
    [PopupID.THREE_STAR_REWARD_MENU]: ThreeStarRewardMenuHandler;
    [PopupID.SEND_GIFT_MENU]: SentGiftMenuHandler;
    [PopupID.GIFT_MENU]: GiftMenuHandler;
    [PopupID.CROP_UNLOCKED_SHARE_MENU]: CropUnlockedShareHandler;
    [PopupID.LEVEL_POPUP]: LevelPopup;
    [PopupID.BUY_BOOSTER_POPUP]: BuyBoosterPopup;
    [PopupID.LEVEL_COMPLETE_POPUP]: LevelCompletePopup;
    [PopupID.STREAK_INFO_POPUP]: StreakInfoPopup;
    [PopupID.GDPR_POPUP]: GDPRMenuHandler;
    [PopupID.CONFIRM_QUIT_GAME]: ConfirmQuitGameHandler;
    [PopupID.ERROR_POPUP]: ErrorPopupHandler;
    [PopupID.CONFIRM_SIGN_OUT_MENU]: ConfirmSignOutMenuHandler;
    [PopupID.DATA_CONFLICT_POPUP]: DataConflictsMenuHandler;
    [PopupID.WHEEL]: WheelPopup,
    [PopupID.WHEEL_QUIT_CONFIRM]: WheelQuitConfirmPopup,
    [PopupID.FARM_HUD]: FarmHUDHandler,
    [PopupID.FARM_MAP]: FarmMapHandler,
    [PopupID.FARM_AREA_UNLOCK]: AreaUnlockPopup,
    [PopupID.FARM_UNLOCK_ITEMS]: UnlockItemsPopup,
    [PopupID.FARM_SHARE]: FarmSharePopup,
    [PopupID.FARM_CATALOGUE]: FarmCatalogueMenuHandler;
    [PopupID.FARM_MINI_GAME]: FarmMiniGameMenuHandler;
    [PopupID.CONNECT_FB_POPUP]: ConnectFbPopup,
    [PopupID.CONNECT_FB_SPLASH_SCREEN]: ConnectFbSplashScreen,
    [PopupID.PROGRESSION_PASSED_MOBILE_VERSION]: ProgressionPassedMobileVersion,
    [PopupID.EVENT_OFFER]: EventOfferHandler,
    [PopupID.LEVEL_POPUP_SIDE_MENU]: SideMenu,
    [PopupID.EVENT_INTRO]: EventIntroHandler
};

export type OnShowProps<ID extends PopupID> = PopupTypeById[ID] extends { onShow(props: infer U): any } ? U : never;

export interface PopupActionPayload {
    popupID: PopupID;
    params?: any;
}

export const UIActions = {
    showPopup: createAction(Types.SHOW_POPUP, resolve => <ID extends PopupID>(popupID: ID, params: OnShowProps<ID>) =>
        resolve<PopupActionPayload>({ popupID, params })
    ),
    hidePopup: createAction(Types.HIDE_POPUP, resolve => <ID extends PopupID>(popupID: ID) =>
        resolve<PopupActionPayload>({ popupID })
    ),
    queuePopup: createAction(Types.QUEUE_POPUP, resolve => <ID extends PopupID>(popupID: ID, params: OnShowProps<ID>) =>
        resolve<PopupActionPayload>({ popupID, params })
    ),
    updateParams: createAction(Types.UPDATE_PARAMS, resolve => <ID extends PopupID>(id: string, popupID: ID, params: OnShowProps<ID>) =>
        resolve<PopupActionPayload & { id: string }>({ id, popupID, params })
    ),
};
